import { Component } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ApiService} from "../../../services/api.service";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {ActionsContainerComponent} from "../../../core/actions-container/actions-container.component";
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {Location, NgClass, NgIf} from "@angular/common";
import {MatProgressBarModule} from "@angular/material/progress-bar";

@Component({
  selector: 'app-chatbot-context-var-train',
  standalone: true,
  imports: [
    ActionsContainerComponent,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    NgIf,
    NgClass,
    MatProgressBarModule
  ],
  templateUrl: './chatbot-context-var-train.component.html'
})
export class ChatbotContextVarTrainComponent {
  chatbotUuid?: string
  contextVar?: string
  form: FormGroup
  loading = false
  error: any

  constructor(
    readonly route: ActivatedRoute,
    readonly router: Router,
    readonly api: ApiService,
    readonly location: Location,
    readonly fb: FormBuilder) {
    this.chatbotUuid = this.route.snapshot.params['chatbotUuid']
    this.contextVar = this.route.snapshot.params['contextVar']
    this.form = this.fb.group({
      id: [null],
      text: ['', Validators.required],
      source: [null],
    })
  }

  save() {
    if (this.form.valid) {
      const data = this.form.value
      this.loading = true
      this.error = undefined
      this.api.createChatbotTrainData(this.chatbotUuid!, this.contextVar!, data).subscribe({
        next: (r) => {
          this.loading = false
          this.router
            .navigate(['chatbots', this.chatbotUuid, 'rag-context', this.contextVar])
            .finally(() => {
            })
        },
        error: (e) => {
          this.error = e
          this.loading = false
        }
      })
    }
  }
}
